import { EEntranceType } from '../../../../json_query';
import { IEntranceTypesTag } from '../../../state/tags/definitions/entrance';
import { getMultiSelectionParamTagItem } from './fabrics/multi_selection_param_tag';

const buildingClassMap = {
  [EEntranceType.SeparateCourtyard]: 'Отдельный вход со двора',
  [EEntranceType.SeparateStreet]: 'Отдельный вход с улицы',
  [EEntranceType.CommonCourtyard]: 'Общий вход со двора',
  [EEntranceType.CommonStreet]: 'Общий вход с улицы',
};

export const EntranceTypesTagItem = getMultiSelectionParamTagItem<EEntranceType, IEntranceTypesTag>(buildingClassMap);
